/** @format */

import {Typography} from '@mui/material';

import {ValueChangeCellBeforeText, ValueChangeCellAfterText} from '../../style';

interface SingleValueDisplayProps {
  text: string;
  variant: 'before' | 'after';
}

const SingleValueDisplay = ({text, variant}: SingleValueDisplayProps) => {
  const StyledContainer =
    variant === 'before' ? ValueChangeCellBeforeText : ValueChangeCellAfterText;

  return (
    <StyledContainer>
      <Typography>{text}</Typography>
    </StyledContainer>
  );
};

export default SingleValueDisplay;
